import React from "react";
import { Box, Paper, Grid } from "@mui/material";
import { downloadFile } from "src/app-redux/common-actions/";
import { useAppDispatch } from "src/app-redux/hooks";
import CommonButtonDefault from "src/components/CommonButton/CommonButtonDefault";
import { CardItem } from "./CardItem";

interface Props {
  RowData: any;
  index: any;
  deleteDoc?: any;
}

export const Card = ({ RowData, index, deleteDoc }: Props) => {
  const dispatch = useAppDispatch();
  const { type, fileExtension, inputBy, inputDate, fileName, comment, id } = RowData;
  const handleClickDownload = async (id: string) => {
    await dispatch(downloadFile(`get-document-url/${id}`, ""));
  };
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row" key={`${index}abs`}>
            <Grid container direction="row" key={index} xs={12} md={10}>
              <CardItem field="File Extension" value={fileExtension} />
              <CardItem field="File Name" value={fileName} />
              <CardItem field="Input By" value={inputBy} />
              <CardItem field="Input Date" value={inputDate} isDateField />
              <CardItem field="Type" value={type} />
              <CardItem field="Comment" value={comment} asHtml />
            </Grid>
            <Grid item xs={12} md={2}>
              <Box mb={2} textAlign="right" display="flex" flexDirection="column">
                {/* <Box component="span">
                  <>
                    <CommonButtonDefault onClick={() => deleteDoc(id)}>Remove</CommonButtonDefault>
                  </>
                </Box> */}
                <Box component="span">
                  <>
                    <CommonButtonDefault isGreen onClick={() => handleClickDownload(id)}>
                      Download
                    </CommonButtonDefault>
                  </>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
